// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__MHduz","loaderOuter":"PageOverlayLoader_loaderOuter__34ewD"};